import { styled } from '@material-ui/core';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { JostTitle } from 'Web/Components/Widgets/Typographies';

import { GestureEvent } from '../../../../../Events/withEvent';
import { useVisibility } from '../../../../../Hooks/useVisibility';
import { DebugDialog } from '../../../../../Web/Context/Debug/DebugDialog';
import { useAuthenticatedUser } from '../../../../../Web/Hooks/User/useAuthenticatedUser';
import { useMapContext } from '../../../Context/MapContext';
import { updateRoomsWallStartDirection, useLaizeCalcDialog } from './LaizeCalcDialogProvider';
import { Toast } from 'Web/Services/ToastService';
import { RoomType } from 'Plugins/FloorPlan/Models/IRoom';

export const LAIZE_CALC_DIALOG_HEADER_HEIGHT = 71;

type LaizeCalcDialogHeaderProps = { onClose: VoidFunction };
export default function LaizeCalcDialogHeader({ onClose }: LaizeCalcDialogHeaderProps) {
    const visibility = useVisibility();
    const isBoUser = useAuthenticatedUser().isBoUser;
    const { state, laizeResult = {}, validCurrentWallStarts } = useLaizeCalcDialog();
    const map = useMapContext();

    const onCloseStudio = (e: GestureEvent) => {
        e.stopPropagation();
        if (validCurrentWallStarts.some((x) => !x.isValid)) {
            Toast.error('LaizeCalcDialog_Toast_Error_InvalidWallStartDirections');
        }
        map.update({
            values: { rooms: updateRoomsWallStartDirection(map.state.rooms, state.rooms, validCurrentWallStarts) },
            mapModified: true,
            logs: { event: 'update updateRoomsWallStartDirection from onCloseStudio' },
        });
        onClose();
    };

    return (
        <Container>
            <ButtonBack onClick={onCloseStudio}>
                <BackArrow />
                <BackTitle>
                    <FormattedMessage id="LaizeCalcDialog_Back" />
                </BackTitle>
            </ButtonBack>
            <Title style={{ cursor: isBoUser ? 'pointer' : 'unset' }} onClick={visibility.show}>
                {map.state.type === RoomType.Stairs ? (
                    <FormattedMessage id="LaizeCalcDialog_Stairs_Title" />
                ) : (
                    <FormattedMessage id="LaizeCalcDialog_Title" />
                )}
            </Title>
            {visibility.visible && (
                <DebugDialog
                    title={
                        map.state.type === RoomType.Stairs ? (
                            <FormattedMessage id="LaizeCalcDialog_Stairs_Title" />
                        ) : (
                            <FormattedMessage id="LaizeCalcDialog_Title" />
                        )
                    }
                    data={{ state, laizeResult }}
                    onClose={visibility.hide}
                />
            )}
        </Container>
    );
}

const Container = styled('div')({
    width: '100%',
    minHeight: LAIZE_CALC_DIALOG_HEADER_HEIGHT,
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#FFFFFF',
});

const ButtonBack = styled('div')({
    cursor: 'pointer',
    position: 'absolute',
    left: 0,
    display: 'flex',
    alignItems: 'center',
    padding: '12px 26px',
    gap: 8,
});
const BackTitle = styled('span')({ fontSize: 12, fontWeight: 400, lineHeight: '16px', color: '#1C1A37' });
const Title = styled(JostTitle)({ color: '#1C1A37', fontSize: 24, lineHeight: '44px', textAlign: 'center' });

const BackArrow = () => (
    <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10.279 18.385a.784.784 0 0 1-1.033.06l-.068-.06L.374 9.663 9.179.94a.783.783 0 0 1 1.1 0 .765.765 0 0 1 .06 1.024l-.063.064L2.57 9.659l7.708 7.635a.765.765 0 0 1 .059 1.022z"
            fill="#13123A"
        />
    </svg>
);
